import React, { useState } from 'react'
import {Button, Dimmer, Grid, Header, Icon, Loader, Message, Segment} from "semantic-ui-react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
var toBlob = require('canvas-toBlob');

const defaultSrc =
    "https://raw.githubusercontent.com/roadmanfong/react-cropper/master/example/img/child.jpg";


const Photo = (props) => {
    const getTerm = props.getTerm;

    const [image, setImage] = useState();
    const [cropData, setCropData] = useState("#");
    const [cropper, setCropper] = useState();
    const [loading, setLoading] = useState(false);
    const [errorString, setError] = useState();

    const onChange = (e) => {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result);
        };

        if (typeof files[0] !== "undefined") {
            reader.readAsDataURL(files[0]);
        }
    };

    const submitForm = (e) => {
        if (typeof cropper !== "undefined") {
            setCropData(cropper.getCroppedCanvas().toDataURL());
            let mimeType = image.substring(image.indexOf(":")+1, image.indexOf(";"));
            console.log(mimeType);

            cropper.getCroppedCanvas({maxHeight: 1000}).toBlob((blob) => {
                props.setCroppedPhoto(blob);

                if (props.participantDetails.PersonStatus === 1)
                {
                    setLoading(true);
                    props.dataManager.updatePhoto(props.jwt, blob)
                        .then(response => {
                            setLoading(false);
                            if (typeof response.data.success !== "undefined") {
                                if (response.data.success == 0) {
                                    setError(response.data.errorMessage);
                                } else {
                                    props.setStep("updateComplete");
                                }
                            }
                            else
                            {
                                setError(response.data);
                                setLoading(false);
                            }
                        });
                }
                else
                {
                    if (props.requirePassword === true) {
                        props.setStep("password");
                    }
                    else {
                        setLoading(true);
                        props.dataManager.submit(props.jwt, blob, null)
                            .then(response => {
                                setLoading(false);
                                if (typeof response.data.success !== "undefined") {
                                    if (response.data.success == 0) {
                                        setError(response.data.errorMessage);
                                    } else {
                                        props.setStep("complete");
                                    }
                                }
                                else
                                {
                                    setError(response.data);
                                    setLoading(false);
                                }
                            });
                    }
                }

            }, mimeType);
        }

    }

    return (
        <div>
            <Dimmer active={loading} inverted>
                <Loader inverted>{getTerm("bda913ca-d13d-11f0-8346-0ac9221eb135", "Loading")}</Loader>
            </Dimmer>

            <Header as='h2'>{getTerm("dcb6cd3a-d146-11f0-8346-0ac9221eb135", "Photo Selection")}</Header>

            { (typeof errorString !== "undefined") &&
                <Message error icon>
                    <Icon name='exclamation' />
                    <Message.Content>
                        <Message.Header>{getTerm("c2d4a314-d13d-11f0-8346-0ac9221eb135", "An error occurred")}</Message.Header>
                        {errorString}
                    </Message.Content>
                </Message>
            }

            <Grid stackable columns={2}>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <p>{getTerm("f4420604-d146-11f0-8346-0ac9221eb135", "You must provide a current digital photo of yourself. This photo will be stored securely on our servers.  Your photo will be used by IATF Global Oversight and approved Proctored Facility personnel as needed to verify your identity. In addition, stakeholders will be able to view your photo when validating your IATF Qualification Certificate.")}</p>
                        <p>{getTerm("0ac56e72-f233-11f0-9cd9-0ac9221eb135", "The photo provided must have been taken within the last 3 months.  (However, the date should NOT be visible on the photo.)")}</p>

                        <div dangerouslySetInnerHTML={{__html: getTerm("4825bcac-d147-11f0-8346-0ac9221eb135", "<p>Please note the following important technical requirements:</p><ul><li>Image must be in <strong>JPEG</strong> or <strong>PNG</strong> format. No other image formats will be accepted.</li><li>Image must be in a <strong>4x6 ratio</strong>, and must be in <strong>portrait orientation</strong>. This is similar to the photo on passports and many forms of Government ID. You will be able to crop the photo after uploading it.</li><li>The image must meet minimum size requirements. If you upload an image that is too small, this will be indicated.</li></ul><br />You are <span class='myBold'>NOT</span> required to use the exact same photo as appears on your passport.  However, the photo should clearly identify you as the same person.")}}>
                            {/* <p>Please note the following important technical requirements:</p>
                            <ul>
                                <li>Image must be in <strong>JPEG</strong> or <strong>PNG</strong> format.  No other image formats will be accepted.</li>
                                <li>Image must be in a <strong>4x6 ratio</strong>, and must be in <strong>portrait orientation</strong>.  This is similar to the photo on passports and many forms of Government ID.  You will be able to crop the photo after uploading it.</li>
                                <li>The image must meet minimum size requirements.  If you upload an image that is too small, this will be indicated.</li>
                            </ul> */}
                        </div>
                        <br />
                        <input className='ui button' type="file" accept="image/jpeg,image/png" onChange={onChange} />
                        <br />
                        <br />

                    </Grid.Column>
                    <Grid.Column width={8}>
                        { (typeof image == "undefined" ) &&
                            <Segment placeholder style={{ height: 400, width: "100%" }}>
                                <Header icon>
                                    <Icon name='photo' />
                                    {getTerm("b8918f98-d147-11f0-8346-0ac9221eb135", "Upload a photo using the \"Choose File\" option.")}
                                </Header>
                            </Segment>
                        }
                        { (typeof image !== "undefined" ) &&
                        <div><Cropper
                            style={{ height: 400, width: "100%" }}
                            aspectRatio={4/6}
                            initialAspectRatio={4/6}
                            preview=".img-preview"
                            src={image}
                            viewMode={1}
                            minCropBoxHeight={300}
                            minCropBoxWidth={200}
                            background={false}
                            responsive={true}
                            autoCropArea={1}
                            zoomable={false}
                            zoomOnWheel={false}
                            zoomOnTouch={false}
                            checkOrientation={false}
                            onInitialized={(instance) => {
                                setCropper(instance);
                            }}
                            guides={true}
                        />
                            <Message size='tiny' warning attached='bottom'>
                                <Icon name='warning' />
                                {getTerm("d9a3d4a2-d147-11f0-8346-0ac9221eb135", "Drag the rectangle to ensure your photo is centered in the highlighted shape.")}
                            </Message>
                        </div>
                        }
                    </Grid.Column>
                </Grid.Row>
            </Grid>

            <div style={{marginTop: '2em'}}>
                <Button onClick={() => props.setStep("reviewCustomization")} style={{ visibility: props.allowPrevious ? 'visible' : 'hidden'}}>{getTerm("403eb9da-d787-11f0-9cd9-0ac9221eb135", "Previous Step")}</Button>
                {(props.participantDetails.PersonStatus === 5)
                    ? <Button disabled={typeof image === "undefined"} style={{float: 'right'}} type='submit' onClick={submitForm} primary>{getTerm("d07f78a4-d13d-11f0-8346-0ac9221eb135", "Next Step")}</Button>
                    : <Button disabled={typeof image === "undefined"} style={{float: 'right'}} type='submit' onClick={submitForm} primary>{getTerm("df2070d8-f231-11f0-9cd9-0ac9221eb135", "Complete Update")}</Button>
                }
            </div>
        </div>
    )
}

export default Photo;